import React from 'react';
import { DomainLanding } from './components/DomainLanding';
export function App() {
  return <DomainLanding data-id="element-0" />;
}